import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const useUTMHandler = () => {
  const [utmSaved, setUTMSaved] = useState(false)
  const validUtmParams = ['utm_content', 'utm_medium', 'utm_source', 'utm_campaign', 'utm_term']
  const navigate = useNavigate()
  const getUTMParams = () => {
    const parameters = new URLSearchParams(window.location.search)
    return Array.from(parameters.entries()).filter(([key]) => validUtmParams.includes(key))
  }

  const saveUTMParams = () => {
    const utmParameters = getUTMParams()
    let hasUTMParam = false
    utmParameters.forEach(([key, value]) => {
      sessionStorage.setItem(key, value)
      hasUTMParam = true
    })
    if (hasUTMParam) {
      setUTMSaved(true)
    }
  }

  const readUTMParams = () => {
    const utmParams: { [key: string]: string } = {}
    for (const param of validUtmParams) {
      const utmParam = localStorage.getItem(param)
      if (utmParam) {
        utmParams[param] = utmParam
      }
    }
    return utmParams
  }

  const deleteUTMParams = () => {
    for (const param of validUtmParams) {
      localStorage.removeItem(param)
    }
  }

  const appendUTMParams = (url: string, readFromLocation: boolean = false) => {
    const params = readFromLocation ? getUTMParams() : readUTMParams()
    const utmAppend = new URLSearchParams(params).toString()
    if (utmAppend) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + utmAppend
    }
    return url
  }

  const navigateWithUTM = (url: string) => {
    navigate(appendUTMParams(url))
  }

  return {
    utmSaved,
    saveUTMParams,
    readUTMParams,
    deleteUTMParams,
    appendUTMParams,
    navigateWithUTM,
  }
}
